var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    {
      staticClass: "mb-2",
      attrs: { "no-body": "", "border-variant": "light" },
    },
    [
      _c(
        "b-card-header",
        {
          staticClass: "p-0 border-light custom-header",
          attrs: { "header-tag": "header", role: "tab" },
        },
        [
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { staticClass: "col-auto" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "text-uppercase fs-14 fw-600",
                      attrs: {
                        variant: _vm.visible
                          ? "custom-green"
                          : "outline-secondary",
                      },
                      on: {
                        click: function ($event) {
                          _vm.displayed = !_vm.displayed
                        },
                      },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.title) + " "),
                      _c(
                        "span",
                        { staticClass: "float-right ml-2" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: _vm.displayed
                                ? "chevron-up"
                                : "chevron-down",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm.supplementaryAgreement.status.code === "signed_by_both" ||
                  _vm.supplementaryAgreement.status.code ===
                    "signed_by_customer"
                    ? _c(
                        "b-button",
                        {
                          staticClass: "ml-2 download-pdf",
                          attrs: {
                            disabled: _vm.pdfLoading,
                            variant: "custom-green",
                            title:
                              "Нажмите, чтобы скачать дополнительное соглашение в формате PDF",
                          },
                          on: { click: _vm.downloadPDF },
                        },
                        [_c("b-icon-file-earmark-pdf")],
                        1
                      )
                    : _vm._e(),
                  _vm.supplementaryAgreement.supplier_signature ||
                  _vm.supplementaryAgreement.customer_signature
                    ? _c("signature-xml-info-button", {
                        staticClass: "ml-2",
                        attrs: {
                          title: `Электронная подпись к дополнительному соглашению №${_vm.supplementaryAgreement.number}`,
                          "supplier-signature":
                            _vm.supplementaryAgreement.supplier_signature,
                          "customer-signature":
                            _vm.supplementaryAgreement.customer_signature,
                          "allow-download-xml":
                            _vm.purchase.flags.is_participant,
                          filename: `supplementary_agreement_${_vm.supplementaryAgreement.number}_signature_info`,
                          mt: 0,
                        },
                      })
                    : _vm._e(),
                  _c("span", { staticClass: "fs-14 fw-600 ml-2" }, [
                    _vm._v(_vm._s(_vm.supplementaryAgreement.status.title)),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-collapse",
        {
          attrs: {
            id: _vm.id,
            accordion: "supplementary-agreements-accordion",
            role: "tabpanel",
          },
          model: {
            value: _vm.displayed,
            callback: function ($$v) {
              _vm.displayed = $$v
            },
            expression: "displayed",
          },
        },
        [
          _c(
            "b-card-body",
            { staticClass: "py-0 px-2" },
            [
              _c("text-row", {
                attrs: {
                  "label-cols-lg": 4,
                  value: _vm.supplementaryAgreement.termination_type.title,
                  compact: "",
                  label: "Основание для расторжения контракта",
                },
              }),
              _c("text-row-price", {
                attrs: {
                  "label-cols-lg": 4,
                  value: _vm.supplementaryAgreement.price,
                  compact: "",
                  label: "Общая стоимость",
                },
              }),
              _c("text-row-date", {
                attrs: {
                  "label-cols-lg": 4,
                  value:
                    _vm.supplementaryAgreement.supplementary_agreement_date,
                  compact: "",
                  label: "Дата заключения дополнительного соглашения",
                },
              }),
              _c("fl44-contract-supplementary-agreement-view-files-table", {
                attrs: {
                  "supplementary-agreement": _vm.supplementaryAgreement,
                },
              }),
              _c(
                "fl44-contract-supplementary-agreement-termination-view-specifications-table",
                {
                  attrs: {
                    items: _vm.supplementaryAgreement.deliverables,
                    "total-cost": _vm.supplementaryAgreement.price,
                  },
                }
              ),
              _vm.supplementaryAgreement
                .supplementary_agreement_disagreements &&
              _vm.supplementaryAgreement.supplementary_agreement_disagreements
                .length > 0
                ? _c("text-row-fl44-old-disagreement-table", {
                    attrs: {
                      disagreements:
                        _vm.supplementaryAgreement
                          .supplementary_agreement_disagreements,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "grey-color mt-3 mb-1 main_text font-weight-bold",
                                },
                                [
                                  _vm._v(
                                    "Разногласия по дополнительному соглашению"
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2973213072
                    ),
                  })
                : _vm._e(),
              (_vm.supplementaryAgreement.status.code === "signed_by_both" ||
                _vm.supplementaryAgreement.status.code ===
                  "signed_by_customer") &&
              _vm.purchase.flags.is_customer &&
              _vm.limitsRequired &&
              _vm.supplementaryAgreement.limits &&
              _vm.supplementaryAgreement.limits.length > 0
                ? [
                    _vm.purchase.status_enum.id === "contract:active" &&
                    _vm.isLimitsEdit
                      ? _c("limits-editable-table", {
                          attrs: {
                            "total-cost": _vm.supplementaryAgreement.price,
                            "limit-year": _vm.purchase.purchase_limit_year,
                            "order-type": {
                              id: _vm.purchase.order_type_id,
                              name: _vm.purchase.order_type_name,
                            },
                            "purchase-type": "fl44_external",
                            "purchase-id": _vm.purchase.id,
                          },
                          on: { validate: _vm.limitsValidate },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "h5",
                                      { staticClass: "grey-color fw-600" },
                                      [_vm._v("Измените лимиты")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3796081880
                          ),
                          model: {
                            value: _vm.form.limits,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "limits", $$v)
                            },
                            expression: "form.limits",
                          },
                        })
                      : _c("limits-table", {
                          attrs: { items: _vm.supplementaryAgreement.limits },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "h5",
                                      { staticClass: "grey-color fw-600" },
                                      [_vm._v("Лимиты по КБК")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3321181564
                          ),
                        }),
                    _vm.purchase.status_enum.id === "contract:active" &&
                    _vm.purchase.contract
                      .last_active_supplementary_agreement_id ===
                      _vm.supplementaryAgreement.id
                      ? [
                          _vm.isLimitsEdit
                            ? [
                                _c(
                                  "b-overlay",
                                  {
                                    staticClass: "d-inline-block",
                                    attrs: {
                                      show: _vm.isLoading,
                                      opacity: "0.6",
                                      rounded: "",
                                      "spinner-small": "",
                                      "spinner-variant": "primary",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "text-uppercase mt-1 mb-3",
                                        attrs: {
                                          variant: "custom-outline-secondary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.isLimitsEdit = false
                                          },
                                        },
                                      },
                                      [_vm._v("Отмена")]
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "text-uppercase mt-1 mb-3 ml-2",
                                        attrs: {
                                          variant: "custom-green",
                                          disabled: !_vm.isLimitsValid,
                                        },
                                        on: { click: _vm.updateLimits },
                                      },
                                      [_vm._v("Сохранить")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "text-uppercase mt-1 mb-3",
                                    attrs: { variant: "custom-green" },
                                    on: { click: _vm.editLimits },
                                  },
                                  [_vm._v("Изменить лимиты")]
                                ),
                              ],
                        ]
                      : _vm._e(),
                  ]
                : _vm._e(),
              (_vm.supplementaryAgreement.status.code === "signed_by_both" ||
                _vm.supplementaryAgreement.status.code ===
                  "signed_by_customer") &&
              _vm.purchase.flags.is_customer &&
              _vm.purchase.contract &&
              _vm.supplementaryAgreement.supplier_accounting
                ? _c("text-row-supplier-accounting", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "grey-color ml-1 mt-3 mb-1 main_text font-weight-bold",
                                },
                                [_vm._v("Банковские реквизиты поставщика")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2488944890
                    ),
                    model: {
                      value: _vm.supplementaryAgreement.supplier_accounting,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.supplementaryAgreement,
                          "supplier_accounting",
                          $$v
                        )
                      },
                      expression: "supplementaryAgreement.supplier_accounting",
                    },
                  })
                : _vm._e(),
              _vm.purchase.contract.latest_supplementary_agreement_id ===
                _vm.supplementaryAgreement.id &&
              _vm.$store.getters.isLoggedIn &&
              _vm.purchase.flags.is_supplier &&
              _vm.purchase.actions.supplier.supplementary_agreement !==
                "disallow"
                ? _c(
                    "private-fl44-contract-supplementary-agreement-supplier-block",
                    {
                      attrs: {
                        "supplementary-agreement": _vm.supplementaryAgreement,
                        purchase: _vm.purchase,
                      },
                      on: {
                        refresh: function ($event) {
                          return _vm.$emit("refresh")
                        },
                      },
                    }
                  )
                : _vm._e(),
              _vm.purchase.contract.latest_supplementary_agreement_id ===
                _vm.supplementaryAgreement.id &&
              _vm.$store.getters.isLoggedIn &&
              _vm.purchase.flags.is_customer &&
              _vm.purchase.actions.customer.supplementary_agreement !==
                "disallow"
                ? _c(
                    "private-fl44-contract-supplementary-agreement-customer-block",
                    {
                      attrs: {
                        contractPriceTotal:
                          _vm.pivc.purchaseitem.contract.price_total,
                        purchase: _vm.purchase,
                        "supplementary-agreement": _vm.supplementaryAgreement,
                      },
                      on: {
                        refresh: function ($event) {
                          return _vm.$emit("refresh")
                        },
                      },
                    }
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }